import { MailSenderType } from 'domains/models/event_type_setting/mail_sender_type';
import { z } from 'zod';

export const MailSenderTypeEnum = z.nativeEnum(MailSenderType);
